import { ICON_CHECK_CIRCLE_OUTLINE } from '@doveit/bricks';
import { BadgeColor } from '@doveit/bricks/dist/typings/components/badge/types';
import { ComputedPropertyStatus } from '../../hooks/use-computed-property-status/useComputedPropertyStatus';
import { statusActionColor, statusActionIcon, statusLabels } from '../../../labels';

export const computedStatusLabels: { [key in ComputedPropertyStatus]: string } = {
  ...statusLabels,
  COLLECTED: 'Incassato',
};

export const computedStatusActionIcon: Record<ComputedPropertyStatus, string> = {
  ...statusActionIcon,
  COLLECTED: ICON_CHECK_CIRCLE_OUTLINE,
};

export const computedStatusActionColor: Record<ComputedPropertyStatus, BadgeColor> = {
  ...statusActionColor,
  COLLECTED: 'success',
};
